<template>
<div class="buy">
    <div class="list" v-loading="loading && page.page==1">
        <el-table :data="tableData" border style="width: 100%" stripe v-if="!noData">
            <el-table-column prop="project" label="套餐名称" align="center"></el-table-column>
            <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
            <el-table-column prop="payType" label="付款方式" align="center">
                <template slot-scope="scope">
                    {{payTypeList.find(item=>item.value==scope.row.payType).label}}
                </template>
            </el-table-column>
            <el-table-column prop="num" label="人数" align="center" v-show="userInfo.role==3"></el-table-column>
            <el-table-column prop="amount" label="金额（元）" align="center"></el-table-column>
        </el-table>
        <div class="no-data" v-else>
            <img src="@/assets/img/user/buy_none.png" />暂无购买记录
        </div>
    </div>
    <div class="next-load" v-if="!noData && tableData.length>5">
        <span v-show="loading"><i class="el-icon-loading"></i>加载中...</span>
        <span v-show="isLast">已加载全部</span>
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    components: {},    
    computed: {
        ...mapGetters({userInfo: "getUser"})
    },
    data() {
        return {
            tableData: [],
            loading: true,
            noData: false,
            page: {
                limit: 10,
                page: 1
            },
            isLast: false,
            payTypeList: [{
                    label: '微信',
                    value: 0
                },
                {
                    label: '支付宝',
                    value: 1
                },
                {
                    label: 'apple',
                    value: 3
                },
            ]
        };
    },
    mounted() {
        this.getList();
        addEventListener("scroll", this.handleScroll, true); //监听函数
    },
    methods: {
        getList() {
            this.$http.get(`/app/order/list`, {
                params: this.page
            }).then(res => {
                this.loading = false;
                if (res.data.code == 0) {
                    this.tableData.push(...res.data.data.list);
                    if (this.tableData.length == 0) {
                        this.noData = true;
                    } else {
                        this.tableData.forEach(ele => {
                            if (ele.vipTaocanType == 1) {
                                ele.project = "个人会员"
                            } else {
                                if (ele.payUse == 1) {
                                    ele.project = `企业${ele.num}人会员`
                                } else if (ele.payUse == 2) {
                                    ele.project = `企业${ele.num}人续费`
                                } else if (ele.payUse == 3) {
                                    ele.project = `企业套餐升级${ele.num}人`
                                }
                            }
                        });
                    }
                    if (this.page.page * this.page.limit >= res.data.data.totalCount) {
                        this.isLast = true;
                    }
                }
            })
        },
        handleScroll() {
            let scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop; //变量scrollTop是滚动条滚动时，距离顶部的距离
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight; //变量windowHeight是可视区的高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight; //变量scrollHeight是滚动条的总高度
            var sum = Math.abs(Math.floor(scrollTop + windowHeight) - scrollHeight);
            if (!this.isLast && sum <= 1 && !this.loading) {
                this.loading = true;
                this.page.page++;
                this.getList();
            }
        }
    },
}
</script>

<style lang="less" scoped>
.buy {
    .list {
        background: #fff;
        min-height: 200px;
        padding: 20px;
    }
}

.next-load {
    height: 40px;
    line-height: 40px;
    position: relative;
    font-size: 14px;
    text-align: center;
    color: #999;

    i {
        font-size: 22px;
        margin-right: 10px;
    }

    &::after {
        position: absolute;
        content: "";
        top: 19px;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #ddd;
        z-index: 2;
    }

    span {
        padding: 0 30px;
        display: inline-block;
        background-color: #f5f5f5;
        position: relative;
        z-index: 10;
    }
}

/deep/.el-table thead {
    color: #666;
}

/deep/.el-table--border th {
    border-right: #eee 1px solid;
    background: #f5f5f5;
    font-weight: 600;
    color: #333;
}

/deep/.el-table td,
/deep/.el-table th.is-leaf {
    border-bottom: #eee 1px solid;
    font-size: 12px;
    font-weight: 600;
    color: #333;
}

/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #f5f5f5;
}
</style>
